import { render, staticRenderFns } from "./SendDialog.vue?vue&type=template&id=f2d51ee4&scoped=true"
import script from "./SendDialog.vue?vue&type=script&lang=js"
export * from "./SendDialog.vue?vue&type=script&lang=js"
import style0 from "./SendDialog.vue?vue&type=style&index=0&id=f2d51ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d51ee4",
  null
  
)

export default component.exports